<template>
  <Layout>
    <AuthWrongCredentials v-if="wrongCredentials" />
    <AuthWrongPassword v-else-if="wrongPassword" />
    <AuthBlockedUser v-else-if="blockedUser" />
    <AuthTooManyRequests v-else-if="tooManyRequests" />

    <div class="pt-8 mx-4">
      <form novalidate @submit.prevent="sendData">
        <div class="max-w-sm mx-auto">
          <div>
            <BaseInputText
              ref="email"
              type="email"
              label="Email"
              name="email"
              class="mb-4"
              :value="email"
              :v="$v.email"
              @input="updateEmail"
            />
          </div>

          <div>
            <BaseInputText
              ref="password"
              type="password"
              label="Contraseña"
              name="password"
              class="mb-4"
              :value="password"
              :v="$v.password"
              @input="updatePassword"
            />
          </div>
        </div>

        <LoadingButton class="mt-8" :loading="sendingData">
          Acceder
        </LoadingButton>

        <div class="flex justify-center">
          <p class="mt-6 text-white hover:underline">
            <router-link :to="{ name: 'PasswordForgotten' }">
              ¿Olvidaste tu contraseña?
            </router-link>
          </p>
        </div>

        <div class="flex justify-center">
          <p class="mt-3 text-white hover:underline">
            <router-link :to="{ name: 'Register', query: $route.query }">
              Si aún no te has registrado, regístrate.
            </router-link>
          </p>
        </div>
      </form>
    </div>
  </Layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import updateFieldMixin from '@/mixins/updateFieldMixin'
import utmParamsMixin from '@/mixins/utmParamsMixin'
import Layout from '@/layouts/AuthLayout'
// import LogoEsriSpain from '@/components/LogoEsriSpain'
import AuthWrongCredentials from '@/components/AuthWrongCredentials'
import AuthWrongPassword from '@/components/AuthWrongPassword'
import AuthBlockedUser from '@/components/AuthBlockedUser'
import AuthTooManyRequests from '@/components/AuthTooManyRequests'
import LoadingButton from '@/components/LoadingButton'

export default {
  components: {
    Layout,
    AuthWrongCredentials,
    AuthWrongPassword,
    AuthBlockedUser,
    AuthTooManyRequests,
    LoadingButton,
  },

  mixins: [validationMixin, updateFieldMixin, utmParamsMixin],

  computed: {
    ...mapState('forms', ['sendingData']),
    ...mapState('auth', [
      'firstName',
      'lastName',
      'email',
      'emailStatus',
      'passwordMinLength',
      'password',
      'wrongCredentials',
      'wrongPassword',
      'blockedUser',
      'tooManyRequests',
    ]),
    ...mapGetters('auth', ['validEmailAddress', 'invalidEmailAddress']),
  },

  mounted() {
    this.$store.commit('forms/setServerErrors', {})
    this.$store.commit('auth/setWrongPassword', false)
    this.$store.commit('auth/setWrongCredentials', false)
    this.$store.dispatch('auth/resetUserData')
    if (this.$refs.email && this.invalidEmailAddress) {
      this.$refs.email.$el.querySelector('input').focus()
    }
  },

  methods: {
    updateEmail(e) {
      this.$store.commit('auth/setWrongCredentials', false)
      this.$store.commit('auth/setWrongPassword', false)
      this.$store.commit('auth/setTooManyRequests', false)
      this.updateField(e, 'auth/updateEmail', 'email')
    },

    updatePassword(e) {
      this.$store.commit('auth/setWrongCredentials', false)
      this.$store.commit('auth/setWrongPassword', false)
      this.$store.commit('auth/setTooManyRequests', false)
      this.updateField(e, 'auth/updatePassword', 'password')
    },

    loginAndRedirect() {
      this.$store.dispatch('auth/resetUserData')
      let url = { name: 'Home' }
      if (this.$route.query.next) url = this.$route.query.next
      this.$router.push(url)
    },

    sendData() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$v.$reset()
        let payload = {
          email: this.email,
          password: this.password,
        }

        const utm_params = this.getUtmParams()
        payload = { ...payload, ...utm_params }

        this.$store.dispatch('auth/loginUser', payload).then(() => {
          this.loginAndRedirect()
        })
      }
    },
  },

  validations() {
    const passLength = this.passwordMinLength

    return {
      email: { required, email },
      password: {
        required,
        minLength: minLength(passLength),
      },
    }
  },
}
</script>
